<template>
    <div class="modal fade" id="modalOrderService" tabindex="-1" role="dialog" aria-labelledby="modalOrderService" aria-hidden="true">
        <div class="modal-dialog modal-xl" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title" id="confirmationModalLabel">{{$t('string.msg.modal.orders.label.title')}}</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                    <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                  <div class="modal-body">
                    <form>
                    <div class="form-row">
                          <div class="form-group col-md-12">
                            <div class="card" v-if="order && order.systemUser">

                                 <div class="card-header">

                                    <div class="form-row" style="background-color:#343B4A; paddind: 15px;">
                                        <h1 class="col-form-label" style="color:white">
                                                {{$t('string.msg.orders.data.truckers.tite')}}
                                            </h1>
                                    </div>
                                    <div class="form-row">
                                        <div class="col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.modal.orders.parts.label.truckdriver')}}:&nbsp; {{` ${camelize(order.systemUser.firstName)} ${camelize(order.systemUser.lastName)}`}}
                                            </label>
                                        </div>
                                        <div v-if="order.truck" class="col-md-8">
                                            <label class="col-form-label">
                                                <strong>{{$t('string.msg.modal.orders.truck.infos')+ ':'}}</strong>&nbsp;{{  $t(order.truck.vehicleType)}}&nbsp;&nbsp;&nbsp;&nbsp;
                                                <strong>{{$t('string.msg.modal.orders.truck.manufacturer')+ ':'}}</strong>&nbsp;{{order.truck.manufacturer.name}}&nbsp;&nbsp;&nbsp;&nbsp;
                                                <strong>{{$t('string.msg.modal.orders.truck.model')+ ':'}}</strong>&nbsp;<span>{{order.truck.model && order.truck.model.name ? order.truck.model.name : ''}}</span>&nbsp;&nbsp;&nbsp;&nbsp;
                                                <strong>{{$t('string.msg.modal.orders.truck.year')+ ':'}}</strong>&nbsp;<span v-if="order.truck.year"></span><span v-else> {{$t('str.msg.uninformed.information')}}</span> {{order.truck.year}}&nbsp;&nbsp;&nbsp;&nbsp;
                                                <strong>{{$t('string.msg.modal.orders.truck.chassi')+ ':'}}</strong>&nbsp;<span v-if="order.truck.chassi"> {{order.truck.chassi}}</span><span v-else> {{$t('str.msg.uninformed.information')}}</span>
                                            </label>
                                        </div>
                                        <div v-else class="col-md-8">
                                            <p style="color:red">
                                                {{ $t('string.msg.nothing.found.truck') }}
                                            </p>
                                        </div>
                                    </div>

                                    <div class="form-row">
                                        <div class="col-md-4">
                                            <label class="col-form-label">
                                                {{$t('string.msg.modal.orders.parts.label.truckdriver.phone')}}:&nbsp; {{` ${(order.systemUser.primaryPhone)}`}}
                                            </label>
                                        </div>
                                       
                                    </div>

                                    <div class="form-row">
                                        
                                        <div class="col-md-3">
                                            <label class="col-form-label">
                                                {{$t('string.msg.dashboard.orders.table.description.title')}}:&nbsp;
                                            </label>
                                            <span>{{` ${camelize(order.description)}`}}</span>
                                        </div>
                                        <div class="col-md-3" v-if="order.serviceFamilies">
                                            <label class="col-form-label">
                                                {{$t('string.msg.dashboard.orders.table.service.title')}}:&nbsp;
                                            </label>
                                            <span>{{` ${camelize(order.serviceFamilies.name)}`}}</span>
                                        </div>
                                        <div v-if="order.paymentMethod && order.paymentType" class="form-group col-md-3">
                                            <label  class="col-form-label">
                                                {{$t('string.msg.order.payment.method.label')}}:
                                            </label> 
                                            <span >{{` ${camelize(order.paymentMethod)}`}}</span>
                                            <span >{{` ${camelize(order.paymentType)}`}}</span>                                        
                                        </div>
                                    </div>
                                    
                                     <div class="form-row" v-if="order.latitude && order.longitude">
                                        
                                        <div class="col-md-6">
                                            <label class="col-form-label">
                                                {{$t('string.msg.orders.location.trucker')}}:&nbsp;
                                            </label>
                                            <GmapMap class="form-group col-md-12"
                                                :center="{lng:order.longitude, lat:order.latitude}"
                                                :zoom="15"
                                                :map-type-id="terrain"
                                                style="width: 2140px; height: 250px"
                                                :options="{
                                                    zoomControl: true,
                                                    mapTypeControl: false,
                                                    scaleControl: false,
                                                    streetViewControl: true,
                                                    rotateControl: false,
                                                    fullscreenControl: true,
                                                    disableDefaultUi: false
                                                    }"
                                            >
                                                <GmapMarker
                                                    :key="index"
                                                    :position="{lng:order.longitude, lat:order.latitude}"
                                                    :clickable="true"
                                                    :draggable="true"
                                                    @click="center=m.position"
                                                />
                                            </GmapMap>
                                        </div>
                                     </div>
                                    {{order.orders.length}}
                                    <div  v-if="order.orders && order.orders.length > 0">
                                        
                                        <div class="form-row">
                                            <div class="col-md-6" style="background-color:#343B4A">
                                                <h1 class="col-form-label" style="color:white">
                                                    {{$t('string.msg.orders.data.company.tite')}}
                                                </h1>
                                            </div>
                                            <div class="col-md-3 text-right" style="background-color:#343B4A">
                                                <h1 class="col-form-label" style="color:white" v-if="order">
                                                    {{toUpperCase($t('string.msg.orders.date.title'))}}:&nbsp;
                                                    {{new Date(order.dateOrder).toLocaleDateString()}} - {{new Date(order.dateOrder).toLocaleTimeString()}}
                                                </h1>
                                            </div>
                                            <div class="col-md-3 text-right" style="background-color:#343B4A">
                                                <h1 class="col-form-label" style="color:white" v-if="data.company">
                                                    {{toUpperCase($t('string.msg.orders.status.title'))}}:&nbsp;{{toUpperCase($t(data.statusOrder.toUpperCase()))}}&nbsp;&nbsp;&nbsp;
                                                </h1>
                                            </div>
                                        </div>
                                        <div class="form-row" v-if="data.company">
                                            <div class="col-md-4" >
                                                <label class="col-form-label">
                                                    {{$t('string.msg.orders.company.name.tite')}}: &nbsp;
                                                </label>
                                                <span>{{String(data.company.fantasyName)}}</span>
                                            </div>
                                            <div class="col-md-4" >
                                                <label class="col-form-label">
                                                    {{$t('string.msg.orders.company.email.title')}}: &nbsp;
                                                </label>
                                                <span>{{String(data.company.email)}}</span>
                                            </div>
                                            <div class="col-md-4" >
                                                <label class="col-form-label">
                                                    {{$t('string.msg.orders.company.phone.title')}}: &nbsp;
                                                </label>
                                                <span>{{String(data.company.primaryPhone)}}</span>
                                            </div>
                                        </div>
                                        <div class="form-row" v-if="data.company">
                                            <div class="col-md-12" >
                                                <label class="col-form-label">
                                                    {{$t('string.msg.orders.company.address.title')}}: &nbsp;
                                                </label>
                                                <span>{{toUpperCase(data.company.idaddress.address) + ', ' + data.company.idaddress.number + ', ' + toUpperCase(data.company.idaddress.neighborhood) + ', ' + data.company.idaddress.cep + ', ' + 
                                                        toUpperCase(data.company.idaddress.city) + ' - ' + toUpperCase(data.company.idaddress.state)}}</span>
                                            </div>
                                        </div>

                                        <div class="form-row" v-if="data.distance">
                                            <div class="col-md-12" >
                                                <label class="col-form-label">
                                                    {{$t('string.msg.dashboard.orders.table.distance.title')}}:
                                                    &nbsp; {{$t((Number(data.distance)/1000).toFixed(2)) + ' KM'}} &nbsp;
                                                </label>
                                            </div>
                                        </div>

                                        <div class="form-row" v-if="data.company && data.statusOrder.toUpperCase() != 'WAITING_FOR_RESPONSE' ">
                                            <div class="col-md-4">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.order.delivery.company.label')}}: &nbsp;
                                                </label>
                                                <span v-if="data.companyIsDelivery == true"> {{$t('string.msg.for.delivery')}}</span>
                                                <span v-if="data.companyIsDelivery == false"> {{$t('string.msg.not.for.delivery')}}</span>
                                                <span v-if="data.companyIsDelivery == null"> {{$t('string.msg.no.information')}}</span>
                                            </div>
                                            <div class="col-md-4">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.order.description.service.label') + ':'}}&nbsp;
                                                </label>
                                                <span v-if="data.companyPartBrand">{{data.companyPartBrand}}</span>
                                                <span v-else>{{$t('string.msg.no.information')}}</span>
                                            </div>
                                            
                                            <div class="col-md-4">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.order.information.ok.label')}} &nbsp;
                                                </label>
                                                <span v-if="data.companyIsInfosSufficient == true">{{toUpperCase($t('string.msg.yes'))}}</span>
                                                <span v-if="data.companyIsInfosSufficient == false">{{toUpperCase($t('string.msg.no'))}}&nbsp;-&nbsp;{{data.companyAddionalInformations}}</span>
                                                <span v-if="data.companyIsInfosSufficient == null">{{$t('string.msg.no.information')}}</span>
                                            </div>
                                        </div>
                                        <div v-if="data.company  && data.total && data.statusOrder.toUpperCase() != 'WAITING_FOR_RESPONSE'" class="form-row" >
                                            <div class="form-group col-md-6">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.modal.orders.price')}}:
                                                </label>
                                                <span >R$ &nbsp; {{data.total.toFixed(2)}}</span>
                                            </div>
                                        </div>

                                        <div v-if="data.statusOrder && data.statusOrder.toUpperCase() == 'REJECTED'" class="form-row" >
                                            <div class="form-group col-md-12">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.modal.orders.description')}}:{{$t(data.statusOrder.toUpperCase())}}&nbsp; 
                                                </label>&nbsp; - &nbsp;
                                                
                                                <label class="col-form-label"> {{$t('string.msg.modal.orders.description.justify')}}: &nbsp; {{data.justifyReject}}</label> 
                                            </div>
                                        </div>
                                        <div v-if="data.statusOrder && data.statusOrder.toUpperCase() == 'CLOSED'" class="form-row" >
                                            <div class="form-group col-md-12">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.modal.orders.description')}}:{{$t(data.statusOrder.toUpperCase())}}
                                                </label>&nbsp; - &nbsp;
                                                <label v-if="data.justifyClose =='response.msg.order.close.by.system'" class="col-form-label"> {{$t('response.msg.order.close.by.system')}}</label> 
                                                <label v-else class="col-form-label"> {{$t('string.msg.modal.orders.description.justify')}}: &nbsp; {{data.justifyClose}}</label> 

                                            </div>
                                            <div v-if="data.userClose" class="form-group col-md-12">
                                                <label class="col-form-label">
                                                    {{$t('string.msg.modal.orders.closed.by')}}:{{data.userClose}}
                                                </label>
                                            </div>
                                        </div>


                                        <div class="form-row">
                                            <div class="form-group col-md-12">
                                                <div class="card" v-if="order && order.systemUser">
                                                    <div class="card-header">
                                                        <div class="form-row">
                                                            <div class="col-md-11">
                                                                <h4 class="text-left">{{$t('string.msg.orders.table.companies.title')}}</h4>
                                                            </div>
                                                            <div class="col-md-1" v-if="order.orders">
                                                                <h4 class="text-center">{{$t('str.total')}}</h4>
                                                                <h4 class="text-center" style="color:grey">{{order.orders.length}}</h4>
                                                            </div>
                                                        </div>
                                                        <br/>
                                                        <div id="table" style="height:300px;overflow-y:scroll">
                                                            <div v-if="order" class="table-responsive">
                                                                <table class="table table-centered table-hover mb-0 cursor-pointer" id="datatable" >
                                                                    <thead>
                                                                        <tr>
                                                                            <th class="border-top-0">{{$t('string.msg.orders.table.company.name.title')}}</th>
                                                                            <th class="border-top-0">{{$t('string.msg.orders.table.company.phone.title')}}</th>
                                                                            <th class="border-top-0">{{$t('string.msg.orders.table.company.email.title')}}</th>
                                                                            <th class="border-top-0">{{$t('string.msg.orders.table.company.status.title')}}</th>
                                                                          
                                                                        </tr>
                                                                    </thead>
                                                                    <tbody>
                                                                        <tr v-bind:key="item._id" v-for="item in order.orders" class="cursor-pointer" @click="selectItem(item)">
                                                                            <td @click="selectItem(item)">
                                                                                <span v-if="item.company">
                                                                                    {{camelize(item.company.socialName)}}
                                                                                </span>
                                                                            </td >
                                                                            <td @click="selectItem(item)">
                                                                                <span v-if="item.company">
                                                                                    {{camelize(item.company.primaryPhone)}}
                                                                                </span>
                                                                            </td>
                                                                            <td @click="selectItem(item)">
                                                                                <span v-if="item.company">
                                                                                    {{camelize(item.company.email)}}
                                                                                </span>
                                                                            </td>
                                                                            <td @click="selectItem(item)">
                                                                                
                                                                                <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'WAITING_FOR_RESPONSE'" style="background-color:#fabc2a; color:black">
                                                                                    &nbsp;&nbsp;&nbsp;{{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp;
                                                                                </span>
                                                                                <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'CLOSED'"  style="background-color:gray; color:white">
                                                                                    &nbsp;&nbsp;&nbsp;{{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp; 
                                                                                </span>
                                                                                <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'PENDING_PAY'" style="background-color:orange; color:white">
                                                                                    &nbsp;&nbsp;&nbsp;{{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp;
                                                                                </span>
                                                                                <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'PAID'" style="background-color:green; color:white">
                                                                                    &nbsp;&nbsp;&nbsp;{{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp;
                                                                                </span>
                                                                                <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'ANSWERED'" style="background-color:blue; color:white">
                                                                                    &nbsp;&nbsp;&nbsp;{{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp; 
                                                                                </span>
                                                                                <span class="status-order" v-if="item.statusOrder.toUpperCase() == 'REJECTED'" style="background-color:red; color:white">
                                                                                    &nbsp;&nbsp;&nbsp;{{$t(item.statusOrder.toUpperCase())}}&nbsp;&nbsp;&nbsp; 
                                                                                </span>
                                                                            </td>
                                                                           
                                                                        </tr>
                                                                    </tbody>
                                                                </table>
                                                            </div>
                                                        </div>
                                                    </div>
                                                </div>
                                            </div>
                                        </div>

                                    </div>
                                    <div v-else>
                                        <div class="form-row">
                                            <div class="col-md-12">
                                                <h4 class="text-center">{{$t('string.msg.orders.zero.companies.received') + ' ;('}}</h4>
                                            </div>
                                        </div>
                                    </div>
                                    
                                </div>

                            </div>

                        </div>
                        
                    </div>

                </form>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal" v-on:click="$emit('confirmation-return', 0)">{{$t('string.msg.term.btn.exit')}}</button>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import Controller from './CrtModalOrderServices';
import Confs from '../../../../../../components/common/Confs';
import * as VueGoogleMaps from 'vue2-google-maps'
import Vue from 'vue'

Vue.use(VueGoogleMaps, {
  load: {
    key: Confs.KEY_MAPS,
    libraries: 'places', 
  }
});
   export default {
        components: {
        },
        props: ["order","trucks"],
        timer: '',
        watch:{
            'order'(){
                this.order = this.order;
                this.data.total = this.order.total;
            },
            'trucks'(){
                this.trucks = this.trucks;
                this.trucks.manufacturer = this.trucks.manufacturer;
            }
        },
        data() {
            return {
                errors: [],
                titleToast: null,
                messageToast: null,
                messageIdToast: null,
                items: [],
                inStock: 'yes',
                delivery: 'yes',
                informationOk: 'yes',
                descriptionPart: null,
                manufacturerName:"",
                companies:[],
                money: {
                    decimal: ',',
                    thousands: '.',
                    prefix: 'R$ ',
                    suffix: '',
                    precision: 2,
                    masked: false /* doesn't work with directive */
                },
                data: {
                }
            }
        },
        methods: Controller.methods,
        created() {
        },
        mounted(){
            // let company = this.$session.get('user').companyUser.company;
            Controller.init(this);
        }
     
}
</script>